// import React, { useState, useMemo } from "react"
// import moment from "moment"

// // ── Event config ──────────────────────────────────────────────────────────────
// const EVENT_CONFIG = {
//   service: {
//     label: "Viewed Service",
//     icon: "fas fa-th-large",
//     color: "#7c3aed",
//     bg: "#f5f3ff",
//     border: "#ddd6fe",
//   },
//   case_study: {
//     label: "Opened Case Study",
//     icon: "fas fa-folder-open",
//     color: "#0369a1",
//     bg: "#e0f2fe",
//     border: "#bae6fd",
//   },
//   website: {
//     label: "Visited Website",
//     icon: "fas fa-globe",
//     color: "#059669",
//     bg: "#d1fae5",
//     border: "#6ee7b7",
//   },
//   null: {
//     label: "Portfolio View",
//     icon: "fas fa-eye",
//     color: "#d97706",
//     bg: "#fef3c7",
//     border: "#fde68a",
//   },
// }

// const getEventConfig = type => EVENT_CONFIG[type] || EVENT_CONFIG["null"]

// // ── Avatar ────────────────────────────────────────────────────────────────────
// const Avatar = ({ name, size = 38 }) => {
//   const initials = name
//     ? name.split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase()
//     : "?"
//   const colors = ["#7c3aed","#0369a1","#059669","#d97706","#dc2626","#0891b2"]
//   const bg = colors[(name?.charCodeAt(0) || 0) % colors.length]
//   return (
//     <div style={{
//       width: size, height: size, borderRadius: "50%",
//       background: bg, color: "#fff",
//       display: "flex", alignItems: "center", justifyContent: "center",
//       fontSize: size * 0.36, fontWeight: 700, flexShrink: 0,
//     }}>
//       {initials}
//     </div>
//   )
// }

// // ── Device icon ───────────────────────────────────────────────────────────────
// const DeviceIcon = ({ device }) => {
//   const icon = device === "Mobile" ? "fas fa-mobile-alt"
//     : device === "Tablet" ? "fas fa-tablet-alt"
//     : "fas fa-desktop"
//   return <i className={icon} style={{ fontSize: 11, color: "#9ca3af" }} title={device} />
// }

// // ── Main Component ────────────────────────────────────────────────────────────
// const PortfolioActivityViewer = ({ data = [] }) => {
//   const [search, setSearch] = useState("")
//   const [typeFilter, setTypeFilter] = useState("all")
//   const [expandedUsers, setExpandedUsers] = useState({})

//   // ── Group by user ─────────────────────────────────────────────────────────
//   const grouped = useMemo(() => {
//     const map = {}
//     data.forEach(row => {
//       const key = row.login_id
//         ? `user_${row.login_id}`
//         : `anon_${row.visitor_ip}`
//       if (!map[key]) {
//         map[key] = {
//           key,
//           name:     row.name  || "Anonymous Visitor",
//           email:    row.email || null,
//           ip:       row.visitor_ip,
//           isAnon:   !row.login_id,
//           events:   [],
//         }
//       }
//       if (
//         typeFilter === "all" ||
//         (row.type || "null") === typeFilter ||
//         (!row.type && typeFilter === "null")
//       ) {
//         map[key].events.push(row)
//       }
//     })
//     // sort events by date asc per user
//     Object.values(map).forEach(u => {
//       u.events.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
//     })
//     return Object.values(map).filter(u => {
//       if (!search) return u.events.length > 0
//       const s = search.toLowerCase()
//       return (
//         u.name.toLowerCase().includes(s) ||
//         (u.email || "").toLowerCase().includes(s) ||
//         u.ip.includes(s)
//       ) && u.events.length > 0
//     })
//   }, [data, search, typeFilter])

//   const toggleUser = key =>
//     setExpandedUsers(p => ({ ...p, [key]: !p[key] }))

//   const totalEvents = data.length
//   const uniqueUsers = new Set(data.map(d => d.login_id ? `u${d.login_id}` : `a${d.visitor_ip}`)).size

//   const typeCounts = useMemo(() => {
//     const c = { all: data.length, service: 0, case_study: 0, website: 0, null: 0 }
//     data.forEach(d => { c[d.type || "null"] = (c[d.type || "null"] || 0) + 1 })
//     return c
//   }, [data])

//   return (
//     <div style={{ fontFamily: "'DM Sans', sans-serif" }}>

//       {/* ── Stats bar ──────────────────────────────────────────────────── */}
//       <div className="row g-3 mb-4">
//         {[
//           { label: "Total Events",    value: totalEvents, icon: "fas fa-bolt",        color: "#7c3aed", bg: "#f5f3ff" },
//           { label: "Unique Visitors", value: uniqueUsers, icon: "fas fa-users",       color: "#0369a1", bg: "#e0f2fe" },
//           { label: "Case Study Views",value: typeCounts.case_study, icon: "fas fa-folder-open", color: "#059669", bg: "#d1fae5" },
//           { label: "Service Clicks",  value: typeCounts.service,    icon: "fas fa-th-large",     color: "#d97706", bg: "#fef3c7" },
//         ].map((s, i) => (
//           <div key={i} className="col-6 col-md-3">
//             <div
//               style={{
//                 background: "#fff",
//                 border: "1px solid #e9e9ef",
//                 borderRadius: 12,
//                 padding: "14px 18px",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 12,
//                 boxShadow: "0 1px 6px rgba(0,0,0,0.05)",
//               }}
//             >
//               <div style={{
//                 width: 38, height: 38, borderRadius: 10,
//                 background: s.bg, display: "flex",
//                 alignItems: "center", justifyContent: "center", flexShrink: 0,
//               }}>
//                 <i className={s.icon} style={{ color: s.color, fontSize: 15 }} />
//               </div>
//               <div>
//                 <div style={{ fontSize: 20, fontWeight: 700, color: "#111827", lineHeight: 1.2 }}>
//                   {s.value}
//                 </div>
//                 <div style={{ fontSize: 11, color: "#6b7280", marginTop: 2 }}>{s.label}</div>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* ── Filters ────────────────────────────────────────────────────── */}
//       <div
//         className="d-flex flex-wrap align-items-center gap-2 mb-3"
//         style={{
//           background: "#fff", border: "1px solid #e9e9ef",
//           borderRadius: 10, padding: "10px 16px",
//           boxShadow: "0 1px 6px rgba(0,0,0,0.05)",
//         }}
//       >
//         {/* Search */}
//         <div className="position-relative" style={{ flex: 1, minWidth: 180 }}>
//           <i className="bx bx-search-alt" style={{
//             position: "absolute", left: 10, top: "50%",
//             transform: "translateY(-50%)", color: "#adb5bd", fontSize: 16,
//           }} />
//           <input
//             type="text"
//             className="form-control form-control-sm"
//             style={{ paddingLeft: 32, borderRadius: 7 }}
//             placeholder="Search by name, email or IP..."
//             value={search}
//             onChange={e => setSearch(e.target.value)}
//           />
//         </div>

//         {/* Type filter pills */}
//         <div className="d-flex gap-1 flex-wrap">
//           {[
//             { key: "all",        label: `All (${typeCounts.all})` },
//             { key: "case_study", label: `Case Study (${typeCounts.case_study})` },
//             { key: "service",    label: `Service (${typeCounts.service})` },
//             { key: "website",    label: `Website (${typeCounts.website})` },
//             { key: "null",       label: `Portfolio (${typeCounts.null})` },
//           ].map(f => (
//             <button
//               key={f.key}
//               onClick={() => setTypeFilter(f.key)}
//               className="btn btn-sm"
//               style={{
//                 borderRadius: 20,
//                 fontSize: 11,
//                 fontWeight: 500,
//                 padding: "3px 12px",
//                 background: typeFilter === f.key ? "#7c3aed" : "#f3f4f6",
//                 color: typeFilter === f.key ? "#fff" : "#374151",
//                 border: "none",
//                 transition: "all 0.15s",
//               }}
//             >
//               {f.label}
//             </button>
//           ))}
//         </div>
//       </div>

//       {/* ── User cards ─────────────────────────────────────────────────── */}
//       <div className="d-flex flex-column gap-3">
//         {grouped.length === 0 ? (
//           <div className="text-center text-muted py-5" style={{ fontSize: 14 }}>
//             No activity records match your filters.
//           </div>
//         ) : (
//           grouped.map(user => {
//             const isOpen = expandedUsers[user.key] !== false // default open
//             const lastEvent = user.events[user.events.length - 1]
//             const firstEvent = user.events[0]

//             return (
//               <div
//                 key={user.key}
//                 style={{
//                   background: "#fff",
//                   border: "1px solid #e9e9ef",
//                   borderRadius: 12,
//                   overflow: "hidden",
//                   boxShadow: "0 1px 6px rgba(0,0,0,0.05)",
//                 }}
//               >
//                 {/* ── User header ─────────────────────────────────────── */}
//                 <div
//                   className="d-flex align-items-center justify-content-between px-3 py-3"
//                   style={{
//                     cursor: "pointer",
//                     background: isOpen ? "#fafafa" : "#fff",
//                     borderBottom: isOpen ? "1px solid #f0f0f0" : "none",
//                     transition: "background 0.15s",
//                   }}
//                   onClick={() => toggleUser(user.key)}
//                 >
//                   <div className="d-flex align-items-center gap-3">
//                     <Avatar name={user.name} size={40} />
//                     <div>
//                       <div className="d-flex align-items-center gap-2 flex-wrap">
//                         <span style={{ fontWeight: 600, fontSize: 14, color: "#111827" }}>
//                           {user.name}
//                         </span>
//                         {user.isAnon && (
//                           <span style={{
//                             fontSize: 10, fontWeight: 500,
//                             background: "#f3f4f6", color: "#6b7280",
//                             borderRadius: 20, padding: "2px 8px",
//                           }}>
//                             Anonymous
//                           </span>
//                         )}
//                       </div>
//                       <div className="d-flex align-items-center gap-2 mt-1 flex-wrap">
//                         {user.email && (
//                           <span style={{ fontSize: 11, color: "#6b7280" }}>
//                             <i className="fas fa-envelope me-1" style={{ fontSize: 10 }} />
//                             {user.email}
//                           </span>
//                         )}
//                         <span style={{ fontSize: 11, color: "#9ca3af" }}>
//                           <i className="fas fa-wifi me-1" style={{ fontSize: 10 }} />
//                           {user.ip}
//                         </span>
//                         <span style={{ fontSize: 11, color: "#9ca3af" }}>
//                           <i className="fas fa-clock me-1" style={{ fontSize: 10 }} />
//                           First: {moment(firstEvent.createdAt).format("DD MMM YYYY, h:mm A")}
//                         </span>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="d-flex align-items-center gap-3">
//                     {/* event count badge */}
//                     <span style={{
//                       background: "#f3e8ff", color: "#7c3aed",
//                       borderRadius: 20, padding: "3px 10px",
//                       fontSize: 11, fontWeight: 600,
//                     }}>
//                       {user.events.length} events
//                     </span>
//                     {/* device + location summary from last event */}
//                     <span style={{ fontSize: 11, color: "#9ca3af" }}>
//                       <DeviceIcon device={lastEvent.device} />
//                       <span className="ms-1">{lastEvent.browser}</span>
//                       <span className="ms-1">· {lastEvent.city}, {lastEvent.country}</span>
//                     </span>
//                     <i
//                       className={`fas fa-chevron-${isOpen ? "up" : "down"}`}
//                       style={{ fontSize: 12, color: "#9ca3af" }}
//                     />
//                   </div>
//                 </div>

//                 {/* ── Event timeline ──────────────────────────────────── */}
//                 {isOpen && (
//                   <div style={{ padding: "16px 20px 12px 20px" }}>
//                     <div style={{ position: "relative" }}>
//                       {/* vertical line */}
//                       <div style={{
//                         position: "absolute",
//                         left: 15, top: 8, bottom: 8,
//                         width: 2,
//                         background: "linear-gradient(to bottom, #e5e7eb, #f3f4f6)",
//                         borderRadius: 2,
//                       }} />

//                       <div className="d-flex flex-column gap-2">
//                         {user.events.map((ev, idx) => {
//                           const cfg = getEventConfig(ev.type)
//                           return (
//                             <div key={ev.id} className="d-flex align-items-start gap-3">
//                               {/* dot on timeline */}
//                               <div style={{ flexShrink: 0, position: "relative", zIndex: 1 }}>
//                                 <div style={{
//                                   width: 30, height: 30, borderRadius: "50%",
//                                   background: cfg.bg, border: `2px solid ${cfg.border}`,
//                                   display: "flex", alignItems: "center", justifyContent: "center",
//                                 }}>
//                                   <i className={cfg.icon} style={{ color: cfg.color, fontSize: 12 }} />
//                                 </div>
//                               </div>

//                               {/* event card */}
//                               <div
//                                 style={{
//                                   flex: 1,
//                                   background: cfg.bg,
//                                   border: `1px solid ${cfg.border}`,
//                                   borderRadius: 9,
//                                   padding: "9px 14px",
//                                   marginBottom: 2,
//                                 }}
//                               >
//                                 <div className="d-flex align-items-start justify-content-between gap-2 flex-wrap">
//                                   <div>
//                                     {/* event type label */}
//                                     <span style={{
//                                       fontSize: 12, fontWeight: 600, color: cfg.color,
//                                     }}>
//                                       {cfg.label}
//                                     </span>

//                                     {/* project name */}
//                                     {ev.project_name && (
//                                       <span style={{
//                                         fontSize: 12, color: "#374151",
//                                         marginLeft: 8,
//                                       }}>
//                                         — <strong>{ev.project_name}</strong>
//                                       </span>
//                                     )}

//                                     {/* service id */}
//                                     {ev.service_id && (
//                                       <span style={{
//                                         fontSize: 11, color: "#6b7280",
//                                         marginLeft: 6,
//                                         background: "#fff",
//                                         border: `1px solid ${cfg.border}`,
//                                         borderRadius: 4,
//                                         padding: "0px 6px",
//                                       }}>
//                                         Service: {ev.service_id}
//                                       </span>
//                                     )}
//                                   </div>

//                                   {/* timestamp */}
//                                   <span style={{ fontSize: 11, color: "#9ca3af", whiteSpace: "nowrap" }}>
//                                     {moment(ev.createdAt).format("DD MMM, h:mm A")}
//                                   </span>
//                                 </div>

//                                 {/* meta row */}
//                                 <div className="d-flex align-items-center gap-3 mt-1 flex-wrap">
//                                   <span style={{ fontSize: 11, color: "#6b7280" }}>
//                                     <DeviceIcon device={ev.device} />
//                                     <span className="ms-1">{ev.device}</span>
//                                   </span>
//                                   <span style={{ fontSize: 11, color: "#6b7280" }}>
//                                     <i className="fab fa-" />
//                                     {ev.browser} · {ev.os}
//                                   </span>
//                                   <span style={{ fontSize: 11, color: "#6b7280" }}>
//                                     <i className="fas fa-map-marker-alt me-1" style={{ fontSize: 9 }} />
//                                     {ev.city}, {ev.region}, {ev.country}
//                                   </span>
//                                 </div>
//                               </div>
//                             </div>
//                           )
//                         })}
//                       </div>
//                     </div>

//                     {/* ── Session summary footer ───────────────────────── */}
//                     <div
//                       className="d-flex align-items-center justify-content-between mt-3 pt-2 flex-wrap gap-2"
//                       style={{ borderTop: "1px solid #f0f0f0" }}
//                     >
//                       <div className="d-flex gap-3 flex-wrap">
//                         {Object.entries(
//                           user.events.reduce((acc, ev) => {
//                             const k = ev.type || "null"
//                             acc[k] = (acc[k] || 0) + 1
//                             return acc
//                           }, {})
//                         ).map(([type, count]) => {
//                           const c = getEventConfig(type)
//                           return (
//                             <span key={type} style={{ fontSize: 11, color: "#6b7280" }}>
//                               <i className={c.icon} style={{ color: c.color, marginRight: 4 }} />
//                               {c.label}: <strong>{count}</strong>
//                             </span>
//                           )
//                         })}
//                       </div>
//                       <span style={{ fontSize: 11, color: "#9ca3af" }}>
//                         Last activity: {moment(lastEvent.createdAt).fromNow()}
//                       </span>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             )
//           })
//         )}
//       </div>
//     </div>
//   )
// }

// export default PortfolioActivityViewer























// import React, { useState } from "react"

// export default function UserTracking({ data = [], caseStudies=[] }) {
//   const [expandedUser, setExpandedUser] = useState(null)

//   // ---- GROUP USERS ----
//   const grouped = data.reduce((acc, item) => {
//     const key = item.email || `guest-${item.visitor_ip}`

//     if (!acc[key]) {
//       acc[key] = {
//         name: item.name,
//         email: item.email,
//         visitor_ip: item.visitor_ip,
//         events: [],
//       }
//     }

//     acc[key].events.push(item)
//     return acc
//   }, {})

//   const formatTime = (date) =>
//     new Date(date).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })

//   const formatDate = (date) =>
//     new Date(date).toLocaleDateString()

//   const typeMap = {
//     service: { icon: "⚙️", color: "#4f46e5" },
//     case_study: { icon: "📄", color: "#059669" },
//     website: { icon: "🌐", color: "#d97706" },
//   }

//   return (
//     <div style={styles.container}>
//       {Object.values(grouped).map((user, i) => {
//         const isOpen = expandedUser === i

//         return (
//           <div key={i} style={styles.userRow}>

//             {/* USER SUMMARY (COMPACT ROW) */}
//             <div
//               style={styles.userHeader}
//               onClick={() => setExpandedUser(isOpen ? null : i)}
//             >
//               <div style={styles.userLeft}>
//                 <div style={styles.avatar}>
//                   {(user.name || "G")[0]}
//                 </div>

//                 <div>
//                   <div style={styles.name}>
//                     {user.name || "Guest"}
//                   </div>
//                   <div style={styles.email}>
//                     {user.email || user.visitor_ip}
//                   </div>
//                 </div>
//               </div>

//               <div style={styles.userRight}>
//                 <span style={styles.badge}>
//                   {user.events.length} events
//                 </span>
//                 <span>{isOpen ? "▲" : "▼"}</span>
//               </div>
//             </div>

//             {/* TIMELINE (EXPANDABLE) */}
//             {isOpen && (
//               <div style={styles.timeline}>
//                 {user.events
//                   .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
//                   .map((e, idx) => {
//                     const t = typeMap[e.type] || {}

//                     return (
//                       <div key={idx} style={styles.eventRow}>

//                         {/* DOT */}
//                         <div style={{
//                           ...styles.dot,
//                           background: t.color
//                         }} />

//                         {/* CONTENT */}
//                         <div style={styles.eventContent}>

//                           <div style={styles.eventTop}>
//                             <span style={{ color: t.color }}>
//                               {t.icon} {e.type}
//                             </span>

//                             <span style={styles.time}>
//                               {formatDate(e.createdAt)} • {formatTime(e.createdAt)}
//                             </span>
//                           </div>

//                           <div style={styles.eventMeta}>
//                             {e.project_name && <span>📁 {e.project_name}</span>}
//                             {e.service_id && <span>⚙️  {caseStudies?.find(i => i.id == e.service_id)?.services}
//                                 </span>}
//                           </div>

//                         </div>
//                       </div>
//                     )
//                   })}
//               </div>
//             )}
//           </div>
//         )
//       })}
//     </div>
//   )
// }

// // ---- STYLES ----
// const styles = {
//   container: {
//     padding: "10px",
//     background: "#f8fafc",
//     fontFamily: "system-ui",
//   },

//   userRow: {
//     background: "#fff",
//     borderRadius: "8px",
//     marginBottom: "8px",
//     border: "1px solid #eee",
//     overflow: "hidden",
//   },

//   userHeader: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     padding: "10px",
//     cursor: "pointer",
//   },

//   userLeft: {
//     display: "flex",
//     alignItems: "center",
//     gap: "10px",
//   },

//   avatar: {
//     width: "32px",
//     height: "32px",
//     borderRadius: "50%",
//     background: "#e0e7ff",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontWeight: "bold",
//   },

//   name: {
//     fontSize: "14px",
//     fontWeight: "600",
//   },

//   email: {
//     fontSize: "12px",
//     color: "#666",
//   },

//   userRight: {
//     display: "flex",
//     alignItems: "center",
//     gap: "10px",
//   },

//   badge: {
//     background: "#eef2ff",
//     padding: "2px 8px",
//     borderRadius: "20px",
//     fontSize: "12px",
//   },

//   timeline: {
//     borderTop: "1px solid #eee",
//     padding: "8px 10px",
//   },

//   eventRow: {
//     display: "flex",
//     gap: "10px",
//     marginBottom: "8px",
//   },

//   dot: {
//     width: "8px",
//     height: "8px",
//     borderRadius: "50%",
//     marginTop: "6px",
//   },

//   eventContent: {
//     flex: 1,
//     fontSize: "13px",
//   },

//   eventTop: {
//     display: "flex",
//     justifyContent: "space-between",
//   },

//   time: {
//     fontSize: "11px",
//     color: "#999",
//   },

//   eventMeta: {
//     display: "flex",
//     gap: "10px",
//     marginTop: "2px",
//     fontSize: "12px",
//     color: "#555",
//   },
// }



import React, { useState } from "react"

export default function UserTracking({ data = [], caseStudies = [] }) {
    const [expandedUser, setExpandedUser] = useState(null)

    // ---- GROUP USERS ----
    const grouped = data.reduce((acc, item) => {
        const key = item.email || `guest-${item.visitor_ip}`

        if (!acc[key]) {
            acc[key] = {
                name: item.name,
                email: item.email,
                visitor_ip: item.visitor_ip,
                events: [],
            }
        }

        acc[key].events.push(item)
        return acc
    }, {})



    const formatTime = (date) =>
        new Date(date).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })

    const formatDate = (date) =>
        new Date(date).toLocaleDateString()

    const typeMap = {
        service: { icon: "⚙️", color: "#4f46e5" },
        case_study: { icon: "📄", color: "#059669" },
        website: { icon: "🌐", color: "#d97706" },
    }

    return (
        <div style={styles.container}>
            {Object.values(grouped).map((user, i) => {
                const isOpen = expandedUser === i

                return (
                    <div key={i} style={styles.userRow}>

                        {/* USER HEADER */}
                        <div
                            style={styles.userHeader}
                            onClick={() => setExpandedUser(isOpen ? null : i)}
                        >
                            <div style={styles.userLeft}>
                                <div style={styles.avatar}>
                                    {(user.name || "G")[0]}
                                </div>

                                <div>
                                    <div style={styles.name}>
                                        {user.name || "Guest"}
                                    </div>

                                    <div style={styles.subInfo}>
                                        {user.email || "Guest User"}
                                    </div>

                                    {/* ✅ IP SHOWN HERE */}
                                    <div style={styles.ip}>
                                        IP: {user.visitor_ip || "-"}
                                    </div>
                                </div>
                            </div>

                            <div style={styles.userRight}>
                                <span style={styles.badge}>
                                    {user.events.length}
                                </span>
                                <span style={styles.toggle}>
                                    {isOpen ? "▲" : "▼"}
                                </span>
                            </div>
                        </div>

                        {/* EVENTS */}
                        {isOpen && (
                            <div style={styles.timeline}>
                                {user.events
                                    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                                    .map((e, idx) => {
                                        const t = typeMap[e.type] || {}

                                        return (
                                            <div key={idx} style={styles.eventRow}>

                                                <div style={{
                                                    ...styles.dot,
                                                    background: t.color
                                                }} />

                                                <div style={styles.eventContent}>

                                                    <div style={styles.eventTop}>
                                                        <span style={{ color: t.color }}>
                                                            {t.icon} {e.type}
                                                        </span>

                                                        <span style={styles.time}>
                                                            {formatDate(e.createdAt)} • {formatTime(e.createdAt)}
                                                        </span>
                                                    </div>

                                                    <div style={styles.eventMeta}>
                                                        {e.project_name && <span>📁 {e.project_name}</span>}
                                                        {e.service_id && <span>⚙️  {caseStudies?.find(i => i.id == e.service_id)?.services}
                                                        </span>}
                                                    </div>

                                                </div>
                                            </div>
                                        )
                                    })}
                            </div>
                        )}
                    </div>
                )
            })}
        </div>
    )
}

// ---- STYLES ----
const styles = {
    container: {
        padding: "10px",
        background: "#f8fafc",
        fontFamily: "system-ui",
    },

    userRow: {
        background: "#fff",
        borderRadius: "8px",
        marginBottom: "8px",
        border: "1px solid #eee",
        overflow: "hidden",
    },

    userHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px",
        cursor: "pointer",
    },

    userLeft: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
    },

    avatar: {
        width: "32px",
        height: "32px",
        borderRadius: "50%",
        background: "#e0e7ff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
    },

    name: {
        fontSize: "14px",
        fontWeight: "600",
    },

    subInfo: {
        fontSize: "12px",
        color: "#666",
    },

    ip: {
        fontSize: "11px",
        color: "#999",
    },

    userRight: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
    },

    badge: {
        background: "#eef2ff",
        padding: "2px 8px",
        borderRadius: "20px",
        fontSize: "12px",
    },

    toggle: {
        fontSize: "12px",
        color: "#666",
    },

    timeline: {
        borderTop: "1px solid #eee",
        padding: "8px 10px",
    },

    eventRow: {
        display: "flex",
        gap: "10px",
        marginBottom: "8px",
    },

    dot: {
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        marginTop: "6px",
    },

    eventContent: {
        flex: 1,
        fontSize: "13px",
    },

    eventTop: {
        display: "flex",
        justifyContent: "space-between",
    },

    time: {
        fontSize: "11px",
        color: "#999",
    },

    eventMeta: {
        display: "flex",
        gap: "10px",
        marginTop: "2px",
        fontSize: "12px",
        color: "#555",
    },
}